// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesFilters_container__tHdbb","chipsSelector":"CategoriesFilters_chipsSelector__GFmPe","unselectedChip":"CategoriesFilters_unselectedChip__LXEof"};